import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PermissionRoutingModule } from './permissions-routing.module';
import { PermissionsComponent } from './permissions.component';
import { PermissionsGridComponent } from './permissions-grid/permissions-grid.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PermissionsEditComponent } from './permissions-edit/permissions-edit.component';
import { NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsAdminComponent } from './permissions-admin/permissions-admin.component';
import { PermissionsLobbyComponent } from './permissions-lobby/permissions-lobby.component';
import { PermissionsReportsComponent } from './permissions-reports/permissions-reports.component';
import { PermissionsAppointmentConciergeComponent } from './permissions-appointment-concierge/permissions-appointment-concierge.component';
import { SharedModule } from '.././../shared/shared.module';
import { DisableControlDirective } from './shared/directives/disable-control.directive';

@NgModule({
  declarations: [DisableControlDirective,PermissionsComponent, PermissionsGridComponent, PermissionsEditComponent, PermissionsAdminComponent, PermissionsLobbyComponent, PermissionsReportsComponent, PermissionsAppointmentConciergeComponent],
  imports: [
    CommonModule,
    PermissionRoutingModule,
    GridModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SharedModule
  ]
})
export class PermissionModule { }
